import { motion } from "framer-motion";
import { Apple, Smartphone } from "lucide-react";
import { Button } from "../components/button";

export function CallToActionSection() {
  return (
    <motion.section
      id="download-cta"
      className="relative w-full py-20 md:py-32 bg-gradient-to-r from-primary to-accent overflow-visible"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, amount: 0.5 }}
      transition={{ duration: 0.8 }}
    >
      <div className="container mx-auto px-4 md:px-6 text-center relative z-10">
        <motion.h2
          className="text-3xl font-bold tracking-tight sm:text-4xl md:text-5xl mb-6 text-primary-foreground"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.5, delay: 0.2, ease: "easeOut" }}
        >
          Download PrepAiro and Explore the Power of UPSC prep
        </motion.h2>
        <motion.p
          className="text-lg text-primary-foreground/90 max-w-2xl mx-auto mb-8"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.5, delay: 0.4, ease: "easeOut" }}
        >
          With AI powered and gamified features one can excel in the exam.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.5, delay: 0.6, ease: "easeOut" }}
        >
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button
              variant="download"
              className="w-full sm:w-auto lg:w-60 group"
              href="https://go.prepairo.ai/site-playstore"
            >
              <Smartphone className="w-5 h-5 group-hover:animate-bounce" />
              Download for Android
            </Button>

            <Button
              variant="download"
              className="w-full sm:w-auto lg:w-60 group"
              href="https://go.prepairo.ai/site-appstore"
            >
              <Apple className="w-5 h-5 group-hover:animate-bounce" />
              Download for iOS
            </Button>
          </div>
        </motion.div>
      </div>

      <motion.div
        className="absolute bottom-4 right-4 w-24 h-24 sm:w-32 sm:h-32 md:w-40 md:h-40 lg:w-48 lg:h-48 pointer-events-none z-10"
        initial={{ opacity: 0, x: 50, y: 20, rotate: 10 }}
        whileInView={{ opacity: 1, x: 0, y: 0, rotate: -5 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.8, delay: 0.4, ease: "easeOut" }}
      >
        <img
          src={`${process.env.PUBLIC_URL}/mascot.png`}
          alt="PrepAiro mascot"
          className="w-full h-full object-contain drop-shadow-2xl"
        />
      </motion.div>
    </motion.section>
  );
}
